/**
 * Date preset options for meeting list filtering
 */
export const MEETING_DATE_PRESETS = {
  UPCOMING: 'upcoming',
  LAST_30: 'last30',
  THIS_MONTH: 'thisMonth',
  LAST_90: 'last90',
  CUSTOM: 'custom',
};

/**
 * Human-readable labels for date presets
 */
export const MEETING_DATE_PRESET_LABELS = {
  [MEETING_DATE_PRESETS.UPCOMING]: 'Upcoming',
  [MEETING_DATE_PRESETS.LAST_30]: 'Last 30 Days',
  [MEETING_DATE_PRESETS.THIS_MONTH]: 'This Month',
  [MEETING_DATE_PRESETS.LAST_90]: 'Last 90 Days',
  [MEETING_DATE_PRESETS.CUSTOM]: 'Custom',
};

/**
 * Array of date preset options for use in dropdowns
 */
export const MEETING_DATE_PRESET_OPTIONS = [
  { value: '', label: 'All Dates' },
  { value: MEETING_DATE_PRESETS.UPCOMING, label: MEETING_DATE_PRESET_LABELS[MEETING_DATE_PRESETS.UPCOMING] },
  { value: MEETING_DATE_PRESETS.LAST_30, label: MEETING_DATE_PRESET_LABELS[MEETING_DATE_PRESETS.LAST_30] },
  { value: MEETING_DATE_PRESETS.THIS_MONTH, label: MEETING_DATE_PRESET_LABELS[MEETING_DATE_PRESETS.THIS_MONTH] },
  { value: MEETING_DATE_PRESETS.LAST_90, label: MEETING_DATE_PRESET_LABELS[MEETING_DATE_PRESETS.LAST_90] },
  { value: MEETING_DATE_PRESETS.CUSTOM, label: MEETING_DATE_PRESET_LABELS[MEETING_DATE_PRESETS.CUSTOM] },
];
